import { useNavigate } from 'react-router-dom';

import { CardType } from '@/types';
import { Button, Icon, Typography } from '@/ui';

import type { HomeCardPropsWithoutCallbacks } from '@/types';
import type { FC } from 'react';

type BiweeklyCardProps = {
  card: HomeCardPropsWithoutCallbacks;
};

// Rendered when the member has completed a chemistry call with a bookable,
// Moments-backed coach (see Cards/index.tsx MeetCoachCardGate decision table).
const BiweeklyCard: FC<BiweeklyCardProps> = ({ card }) => {
  const navigate = useNavigate();
  const { coach } = card;
  const isBookableCoachCard =
    card.type === CardType.MEET_COACH ||
    card.type === CardType.PREVIOUS_SESSION;
  if (!isBookableCoachCard || !coach?.id) return null;

  const coachName =
    ('fullName' in coach && coach.fullName) || coach.firstName || 'your coach';
  const coachFirstName =
    ('firstName' in coach && coach.firstName) ||
    ('fullName' in coach && coach.fullName.split(' ')[0]) ||
    'your coach';

  return (
    <div className="flex w-full flex-col gap-4 rounded-xl bg-white px-6 py-5 shadow-sm md:flex-row md:items-center md:gap-6 md:px-8">
      <Icon className="text-cement-500">calendar_today</Icon>
      <Typography className="shrink-0 font-bold" variant="body1">
        You have no upcoming sessions
      </Typography>
      <Typography className="text-cement-700 flex-1" variant="body1">
        Schedule biweekly coaching sessions with{' '}
        <span className="font-bold">{coachName}</span> to keep up the momentum!
      </Typography>
      <Button
        className="md:shrink-0"
        color="primary"
        variant="contained"
        onClick={() => navigate(`/m/book-biweekly/${coach.id}`)}
      >
        Schedule with {coachFirstName}
      </Button>
    </div>
  );
};

export default BiweeklyCard;
